var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33342 12.4997V37.4997H41.6668V12.4997H8.33342ZM8.33342 8.33301H41.6668C42.7718 8.33301 43.8316 8.77199 44.613 9.5534C45.3944 10.3348 45.8334 11.3946 45.8334 12.4997V37.4997C45.8334 38.6047 45.3944 39.6645 44.613 40.4459C43.8316 41.2273 42.7718 41.6663 41.6668 41.6663H8.33342C7.22835 41.6663 6.16854 41.2273 5.38714 40.4459C4.60573 39.6645 4.16675 38.6047 4.16675 37.4997V12.4997C4.16675 11.3946 4.60573 10.3348 5.38714 9.5534C6.16854 8.77199 7.22835 8.33301 8.33342 8.33301ZM15.6251 22.9163C16.4539 22.9163 17.2487 22.5871 17.8348 22.001C18.4208 21.415 18.7501 20.6201 18.7501 19.7913C18.7501 18.9625 18.4208 18.1677 17.8348 17.5816C17.2487 16.9956 16.4539 16.6663 15.6251 16.6663C14.7963 16.6663 14.0014 16.9956 13.4154 17.5816C12.8293 18.1677 12.5001 18.9625 12.5001 19.7913C12.5001 20.6201 12.8293 21.415 13.4154 22.001C14.0014 22.5871 14.7963 22.9163 15.6251 22.9163ZM14.5834 29.1663L18.7501 24.9997L22.9167 29.1663L31.2501 20.833L37.5001 27.083V33.333H14.5834V29.1663Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/IconImage.26141f8a.svg";
export { ForwardRef as ReactComponent };